import { Component, OnInit, ViewEncapsulation, ViewChild, ElementRef, ChangeDetectorRef } from '@angular/core';
import { DataService } from '../../../../Services/DataSharingService';
import { Subscription } from 'rxjs/Subscription';
import { HeaderService } from '../../../../Services/HeaderService';
import { Title } from '@angular/platform-browser';

@Component({
	selector: 'app-accordian-style1',
	templateUrl: './accordian-style1.component.html',
	styleUrls: ['./accordian-style1.component.scss'],
	encapsulation: ViewEncapsulation.None
})
export class AccordianStyle1Component implements OnInit {

	@ViewChild('container', { read: ElementRef }) container: ElementRef;

	private subscription: Subscription[] = [];
	public data: string = '';
	public showCode = '';

	constructor(private _dataService: DataService, private cdRef: ChangeDetectorRef, private _headerService: HeaderService, private _titleService: Title) {
		_titleService.setTitle('Accordian');
		_dataService.GetCode().subscribe(data => {
			this.data = data;
		})
		_dataService.showCode.subscribe(value => {
			this.showCode = value;
		})
	}

	ngOnInit() {
		this._dataService.SetCode(this.container.nativeElement.innerHTML);
	}

	ngOnDestroy(): void {
		this.subscription.map(subscription => {
			subscription.unsubscribe();
		})
	}
	ShowCode(event) {
		this.data = this.container.nativeElement.innerHTML;
		if (this.showCode == 'accordian-style1') {
			this._dataService.setState('');
		} else {
			this._dataService.setState('accordian-style1');
		}
	}
}



// WEBPACK FOOTER //
// ./src/app/features/accordian/accordian-style1/accordian-style1.component.ts